module.exports = __webpack_public_path__ + "img/ka-l6.prt.86788bf1.jpg";